import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@components/Button/Button'
import useStyles from './styles'
import useCommonStyles from '@screens/OnlineCancellation/commonStyles'
import Page from '@components/Page'
import Header from '@components/Header'
import Footer from '@components/Footer'
import { onPhoneClick } from 'src/utils/onPhoneClick'
import { Phone } from '@components/icons/Phone'
import { getImageUrl } from 'src/utils/getImageUrl'
import { ERROR_PLEASE_CALL } from 'src/config/imageUrls'
import { useIsPhoneOnly } from 'src/config/mediaQueries'

interface CancellationNotPossibleProps {
  phone?: string
}

export const CancellationNotPossible = ({ phone }: CancellationNotPossibleProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const commonClasses = useCommonStyles()
  const isPhone = useIsPhoneOnly()

  const ctaButton = (
    <Button
      className={commonClasses.buttonWrapper}
      onClick={() => onPhoneClick(phone)}
      text={phone}
      startIcon={<Phone width={18} height={18} />}
    />
  )

  return (
    <Page
      header={
        <Header desktopHeadingText={t('cancel_appointment_title')} mobileHeadingText={t('cancel_appointment_title')} />
      }
      body={
        <div className={commonClasses.innerWrapper}>
          <div className={commonClasses.contentWrapper}>
            <img src={getImageUrl({ src: ERROR_PLEASE_CALL })} alt={'phone'} />
            <div className={classes.warningText}>{t('appointment_cancellation_not_possible')}</div>
            {phone && !isPhone && ctaButton}
          </div>
        </div>
      }
      footer={phone && isPhone ? <Footer button={ctaButton} /> : undefined}
    />
  )
}
